// @flow

import * as React from 'react';

import { Query } from '../../common/Query';
import DataTable from '../../common/table/Table';

type Props = {
  RowDetail: React.ReactNode,
  connectionName: string,
  query: string,
  columnData: Array<mixed>
};

type State = {
  queryVariables: {},
  query: {},
  filter: {},
  sortBy: null | string,
  sortDir: 'asc' | 'desc',
  after: null | string,
  before: null | string,
  rowsPerPage: number
};

class GraphConnectionTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const state = {
      queryVariables: {},
      query: props.defaultVariables?.query || {},
      filter: {
        name: true,
        email: true,
        phone: true
      },
      sortBy: null,
      sortDir: 'desc',
      rowsPerPage: 25,
      after: null,
      before: null
    };

    state.queryVariables = this.getQueryVariables(state);

    this.state = state;

    this.setVariables = this.setVariables.bind(this);
    this.onPaginationHandler = this.onPaginationHandler.bind(this);
  }

  setVariables(name: string, variables: Object | string | number) {
    const partial = {};
    if (name === 'query' || name === 'rowsPerPage') {
      // Reset cursor
      partial.after = null;
      partial.before = null;
    }
    if (typeof variables === 'object') {
      this.updateState({
        [name]: { ...this.state[name], ...variables },
        ...partial
      });
    } else {
      this.updateState({ [name]: variables, ...partial });
    }
  }

  getQueryVariables(state: State) {
    const {
      query,
      filter,
      sortBy,
      sortDir,
      after,
      before,
      rowsPerPage
    } = state;
    return {
      query,
      filter,
      sortBy,
      sortDir: sortDir.toUpperCase(),
      after,
      before,
      first: (!before && rowsPerPage) || null,
      last: before && rowsPerPage
    };
  }

  updateState(partialState: State) {
    const state = {
      ...this.state,
      ...partialState
    };
    const queryVariables = this.getQueryVariables(state);

    this.setState({ ...partialState, queryVariables });
  }

  onPaginationHandler(page, pageInfo, increment: -1 | 1) {
    if (increment === 1) {
      this.updateState({ after: pageInfo.endCursor, before: null });
    } else if (increment === -1) {
      this.updateState({ before: pageInfo.startCursor, after: null });
    }
  }

  render() {
    const { filter, sortBy, sortDir } = this.state;

    return (
      <Query
        query={this.props.query}
        variables={this.state.queryVariables}
        loading={false}
      >
        {({ data: res, loading }) => {
          const data = res && res[this.props.connectionName];
          const { edges = [], totalCount = 0, pageInfo = {} } = data || {};
          return (
            <DataTable
              saveCookieAs={'user-columns'}
              loading={loading}
              primaryKey="id"
              order={sortDir}
              orderBy={sortBy || 'id'}
              columnData={this.props.columnData}
              RowDetail={this.props.RowDetail}
              defaultHiddenColumnNames={Object.keys(filter).filter(
                (key) => filter[key] === false
              )}
              defaultFilters={this.state.query}
              onPaginationHandler={this.onPaginationHandler}
              defaultRowsPerPage={this.state.rowsPerPage}
              setVariables={this.setVariables}
              data={edges}
              totalCount={totalCount}
              pageInfo={pageInfo}
              {...this.props}
            />
          );
        }}
      </Query>
    );
  }
}

export default GraphConnectionTable;
